<template>
  <main id="counter_from_start" class="lanterns game">
    <template v-if="isGameInitialized && !isGameFinished">
      <img class="img_glow_left" src="/static/images/home/glow.png">

      <section>
        <div class="top_bar">
          <div class="score_section flex-row">
            <p>{{ getTranslations.page_lanterns_your_score }} </p>

            <div class="score">0</div>
          </div>

          <add-on-game-timer
            ref="timerRef"
            :initial-timer-in-seconds="timerForLanternGame"
            @time:expired="handleTimeExpired"
          />
        </div>
      </section>
    </template>

    <base-loader-modal v-if="isLoaderModalOpen" />

    <game-maintenance
      v-else-if="isGameMaintenanceModalOpen"
      @redirect:page="handleGameMaintenanceRedirection"
    />

    <post-game-lantern-modal
      v-else-if="isPostGameModalOpen"
      :score="postGameInfo.score"
      :prize-value="postGameInfo.prizeValue"
    />
  </main>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import $ from 'jquery';
import BaseLoaderModal from '../../../common/modal/BaseLoaderModal.vue';
import GameMaintenance from '../../modals/Maintenance.vue';
import AddOnGameTimer from './components/AddOnGameTimer.vue';
import PostGameLanternModal from './components/PostGameLanternModal.vue';
import { addOnGameStyleMixin } from '../../../../common/mixins/addOnGameStyle';
import modals from '../../../../common/modals';
import { generateRandomNumberInRange, isPositiveNumber } from '../../../../helpers/common';

const mediaSize = window.matchMedia('(max-width: 600px)');

const itemImages = {
  lantern: '/static/images/lanterns/lantern_01.svg',
  lanternSelected: '/static/images/lanterns/lantern_02.svg',
  star: '/static/images/lanterns/lantern_star_01.svg',
  starSelected: '/static/images/lanterns/lantern_star_02.svg',
};

export default {
  name: 'AddOnGameLantern',
  components: { BaseLoaderModal, PostGameLanternModal, GameMaintenance, AddOnGameTimer },
  mixins: [addOnGameStyleMixin],
  data () {
    return {
      isGameInitialized: false,
      isGameFinished: false,
      isLoaderModalOpen: false,
      isGameMaintenanceModalOpen: false,
      isPostGameModalOpen: false,
      score: 0,
      gameIntervalId: null,
      postGameInfo: { score: null, prizeValue: null },
    };
  },
  mounted () {
    if (isPositiveNumber(this.timerForLanternGame)) {
      this.startGame();
    } else {
      this.openMaintenanceModal();
    }
  },
  computed: {
    ...mapState('common', [
      'timerForLanternGame',
      'addOnGameConfig',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapActions('game', [
      'finishAddOnGame',
    ]),
    ...mapMutations('common', [
      'resetAddOnGameConfig',
    ]),
    redirectToHomePage () {
      this.$router.push('/home');
    },
    openMaintenanceModal () {
      this.isGameMaintenanceModalOpen = true;

      modals.setupCommonModal({
        hideImmediate: true,
        afterHideCallback: () => {
          this.isGameMaintenanceModalOpen = false;

          this.redirectToHomePage();
        },
      });
    },
    closeLoaderModalAsPromise () {
      return new Promise(resolve => {
        modals.hideCommonModal({
          immediate: true,
          afterHideCallback: () => {
            this.isLoaderModalOpen = false;
            resolve();
          },
        });
      });
    },
    registerDropItemClickListener () {
      const handleElementClick = (targetEl) => {
        if ($(targetEl).data('test')) {
          this.score++;
        } else {
          this.score--;
        }

        $('.score').text(this.score);

        if (this.score < 0) {
          $('.score').css('color', '#ed3833');
        } else if (this.score > 0) {
          $('.score').css('color', '#7fff94');
        } else {
          $('.score').css('color', '#ffffff');
        }

        if ($(targetEl).hasClass('lantern')) {
          $(targetEl).attr('src', itemImages.lanternSelected);
        } else {
          $(targetEl).attr('src', itemImages.starSelected);
        }

        $(targetEl).css('pointer-events', 'none').fadeOut(2000);
      };

      $(document).on('click', '.box_lanterns', function () {
        handleElementClick(this);
      });
    },
    constructDropItem () {
      const size = mediaSize.matches ? generateRandomNumberInRange(70, 100) : generateRandomNumberInRange(70, 150);
      const left = generateRandomNumberInRange(0, $('.lanterns.game').width() - 50);
      const velocity = generateRandomNumberInRange(2000, 6000);

      const elDropItem = $('<img/>', {
        class: 'box_lanterns',
        src: itemImages.lantern,
        alt: '',
        draggable: false,
        style: `width:${ size }px; height:${ size }px; left:${ left }px; transition: transform ${ velocity }ms linear;`,
      });

      const isLantern = Math.round(Math.random()) === 1;
      elDropItem.data('test', isLantern);

      if (isLantern) {
        elDropItem.addClass('lantern').attr('src', itemImages.lantern);
      } else {
        elDropItem.addClass('star').attr('src', itemImages.star);
      }

      $('.lanterns.game').append(elDropItem);

      setTimeout(() => {
        elDropItem.addClass('move');
      }, generateRandomNumberInRange(0, 5000));

      elDropItem.one('transitionend webkitTransitionEnd oTransitionEnd', function () {
        $(this).remove();
      });
    },
    constructDropItemList () {
      for (let i = 0; i < 10; i++) {
        this.constructDropItem();
      }
    },
    async startGame () {
      await this.addLanternStylesheet();

      this.isGameInitialized = true;

      await this.$nextTick();

      if (this.$refs.timerRef.startTimer) {
        this.$refs.timerRef.startTimer();
      }

      this.registerDropItemClickListener();

      this.constructDropItemList();

      this.gameIntervalId = setInterval(this.constructDropItemList, 5000);
    },
    async gameOver () {
      try {
        this.isGameFinished = true;
        this.isLoaderModalOpen = true;

        modals.setupCommonModal({ hideManually: true });

        const successful = this.score > 0;

        const payload = {
          successful,
          achievementName: `${this.addOnGameConfig.gameId}`,
          gameType: 'LIGHT_THE_LANTERNS',
        };

        const { prizeValue } = await this.finishAddOnGame(payload);

        await this.getUserLoginDetails();

        this.postGameInfo.score = this.score;
        this.postGameInfo.prizeValue = prizeValue;

        await this.closeLoaderModalAsPromise();

        this.isPostGameModalOpen = true;

        modals.setupCommonModal({
          hideImmediate: true,
          afterHideCallback: () => {
            this.isPostGameModalOpen = false;
            this.postGameInfo.score = null;
            this.postGameInfo.prizeValue = null;

            this.redirectToHomePage();
          },
        });
      } catch (_error) {
        await this.closeLoaderModalAsPromise();

        this.openMaintenanceModal();
      }
    },
    removeAllDropItems () {
      document.querySelectorAll('.box_lanterns').forEach(el => el.remove());
    },
    handleTimeExpired () {
      clearInterval(this.gameIntervalId);
      this.removeAllDropItems();

      this.gameOver();
    },
    handleGameMaintenanceRedirection ({ pagePath }) {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.isGameMaintenanceModalOpen = false;

          this.$router.push(pagePath);
        },
      });
    },
  },
  beforeDestroy () {
    this.resetAddOnGameConfig();

    this.removeLanternStylesheet();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/addOnGame/AddOnGameLantern.vue